import { render, staticRenderFns } from "./promotion-sorting.vue?vue&type=template&id=b424d3ee&scoped=true"
import script from "./promotion-sorting.vue?vue&type=script&lang=js"
export * from "./promotion-sorting.vue?vue&type=script&lang=js"
import style0 from "./promotion-sorting.vue?vue&type=style&index=0&id=b424d3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b424d3ee",
  null
  
)

export default component.exports